import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API } from "../api";

// CONSTANTS ------------------------------------------------------------------

const CONVENTION_INITIAL_STATE = {
  abbrev: "",
  announcement: "",
  backgroundStyle: {},
  darkMode: false,
  header: "",
  name: "",
  pending: false,
  products: [],
  pskus: {},
};

// ACTIONS --------------------------------------------------------------------

/**
 * @desc Get convention for current brand.
 */
export const fetchLiveConvention = createAsyncThunk(
  "liveConvention/fetch",
  async (brand, { rejectWithValue }) => {
    try {
      const response = await API.LiveConvention.Get({ params: { brand } });
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

// SLICE ----------------------------------------------------------------------

/**
 * @desc Convention Slice.
 */
export const conventionSlice = createSlice({
  name: "convention",
  initialState: CONVENTION_INITIAL_STATE,
  reducers: {
    reset: (state, _action) => {
      Object.entries(CONVENTION_INITIAL_STATE).forEach(([key, value]) => {
        state[key] = value;
      });
    },
    updateConventionStore: (state, action) => {
      Object.entries(action.payload).forEach(([key, value]) => {
        state[key] = value;
      });
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Convention
      .addCase(fetchLiveConvention.pending, (state) => {
        state.pending = true;
      })
      .addCase(fetchLiveConvention.fulfilled, (state, action) => {
        Object.entries(action.payload).forEach(([key, value]) => {
          state[key] = value;
        });
        state.pending = false;
      })
      .addCase(fetchLiveConvention.rejected, (state) => {
        state.pending = false;
      });
  },
});

// ACTIONS --------------------------------------------------------------------

export const { updateConventionStore } = conventionSlice.actions;

// SELECTORS ------------------------------------------------------------------

export const getConventionSelector = (state) => state.convention;

// REDUCER --------------------------------------------------------------------

export default conventionSlice.reducer;
